import * as React from 'react';
import * as styles from "./MenuItem.css";
import { IAIcon } from '../../../icon/Icon';

export interface IMenuItemProps {
  icon: string;
  title: string;
  iconColor: string;
  titleColor: string;
  style?: React.CSSProperties;
  onClick: () => void;
}

export class MenuItem extends React.Component<IMenuItemProps> {

  public render(): JSX.Element {
    return (
      <div
        className={styles.IA_menuItem}
        style={this.props.style}
        onClick={() => this.props.onClick()}
      >
        <IAIcon
          title={this.props.icon}
          size={22}
          color={this.props.iconColor}
          style={{
            width: 22,
            height: 22,
            float: "left",
            padding: 13
          }}
        />
        <div
          className={styles.IA_title}
          style={{
            color: this.props.titleColor
          }}
        >
          {this.props.title}
        </div>
      </div >
    );
  }
}